import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import { getLatestMovies } from "@/lib/movie";
import { useFavorites } from "@/hooks/useFavorites";

export default function LatestMoviesSection() {
  const latest = getLatestMovies(6);
  const { isFavorite, toggleFavorite } = useFavorites();

  return (
    <section className="w-full max-w-[1360px] mx-auto px-4 md:px-6 py-14 md:py-16">
      <SectionHeading
        title="最新上映"
        subtitle="近期登陆院线的新片速览，第一时间掌握上映动态"
        moreTo="/category/action"
        moreLabel="浏览全部影片"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {latest.map((movie) => (
          <MovieCard
            key={movie.id}
            movie={movie}
            isFavorite={isFavorite(movie.id)}
            onToggleFavorite={toggleFavorite}
          />
        ))}
      </div>
      <div className="sm:hidden mt-6 text-center">
        <Link
          to="/category/action"
          className="inline-flex items-center gap-1 text-sm text-primary-600 cursor-pointer"
        >
          浏览全部影片
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>
    </section>
  );
}